import React from 'react';
import {
  ClassNamesState, ClearIndicatorProps, CommonPropsAndClassName, GroupBase,
} from 'react-select';
/* eslint-disable import-x/no-unresolved */
import { StylesProps } from 'react-select/dist/declarations/src/styles';
import { Close } from '../../icon/Close';

export const getStyleProps = <
  Option,
  IsMulti extends boolean,
  Group extends GroupBase<Option>,
  Key extends keyof StylesProps<Option, IsMulti, Group>,
>(
    props: Pick<
    CommonPropsAndClassName<Option, IsMulti, Group>,
    'cx' | 'getStyles' | 'getClassNames' | 'className'
    > &
    StylesProps<Option, IsMulti, Group>[Key],
    name: Key,
    classNamesState?: ClassNamesState,
  ) => {
  const {
    cx, getClassNames, className,
  } = props;
  return {
    className: cx(classNamesState ?? {}, getClassNames(name, props), className),
  };
};

export default function ClearIndicator(props: ClearIndicatorProps) {
  const { innerProps } = props;
  return (
    <div
      {...getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true,
      })}
      {...innerProps}
    >
      <Close />
    </div>
  );
}
